import { BaseService } from './base.service';
import { ResponseWrapper, ApiError } from './http';

export class SupplierItemsService extends BaseService {
  static get resourceEndpoint() {
    return 'supplier-items';
  }

  static async search(parameters = {}) {
    const params = { ...parameters };
    try {
      const response = await this.request().get(
        `${this.resourceEndpoint}/search`,
        { params }
      );
      return new ResponseWrapper(response);
    } catch (error) {
      throw new ApiError(error);
    }
  }

  static async update_favorite(data = {}) {
    try {
      const response = await this.request().patch(
        `${this.resourceEndpoint}/update_favorite`,
        data
      );
      return new ResponseWrapper(response);
    } catch (error) {
      throw new ApiError(error);
    }
  }
}
